import React from 'react'
import Click from './Click'
import './App.css'

function App() {
  return (
    <div className='App'>
      {/* <h1 className='head'>Form Events</h1> */}
        <Click />
    </div>
  )
}

export default App